import { interaction } from '../actions/dynamicComponents';
import interactionEvent from './definitions/interactionEvent';

const dinamicComponentsEvents = {
  [interaction]: interactionEvent(() => ({})),
};

export default dinamicComponentsEvents;
